import client from './client';

const PATH = '/api/news-events/news-events/';

const list = (params = {}) => client.get(PATH, { params }).then((r) => r.data);
const detail = (slug) => client.get(`${PATH}${slug}/`).then((r) => r.data);

/** Build a multipart FormData payload for news/event create/update. */
const toFormData = (payload) => {
  const fd = new FormData();
  const fields = ['title', 'type', 'date', 'excerpt', 'content'];
  fields.forEach((key) => {
    if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
      fd.append(key, payload[key]);
    }
  });
  // parivar_id travels even as an empty string so a Super Admin can move an
  // item from a specific Parivar back to GLOBAL (all Parivars); the backend
  // treats '' as null. When the key is absent entirely (default) it is simply
  // not sent, so a normal update keeps its existing Parivar.
  if (payload.parivar_id !== undefined && payload.parivar_id !== null) {
    fd.append('parivar_id', payload.parivar_id === '' ? '' : payload.parivar_id);
  }
  if (payload.image instanceof File) fd.append('image', payload.image, payload.image.name);
  if (payload.is_active !== undefined) fd.append('is_active', payload.is_active ? 'true' : 'false');
  return fd;
};

export const newsEventApi = {
  list,
  detail,

  create(payload, { onUploadProgress } = {}) {
    return client.post(PATH, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  update(slug, payload, { onUploadProgress } = {}) {
    return client.patch(`${PATH}${slug}/`, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  remove(slug) {
    return client.delete(`${PATH}${slug}/`).then((r) => r.data);
  },

  publish(slug) {
    return client.post(`${PATH}${slug}/publish/`).then((r) => r.data);
  },

  unpublish(slug) {
    return client.post(`${PATH}${slug}/unpublish/`).then((r) => r.data);
  },
};
